import * as React from 'react';
import {connect} from 'react-redux';

import {Routing} from 'nutshell-core/routing';
import {Session} from 'nutshell-core/session';

import {Checkbox} from 'shells/checkbox/checkbox';
import {Radio} from 'shells/radio/radio';
import {RadioGroupSlider} from 'shells/radio/radio-group-slider';
import {SelectableListSingle} from 'shells/selectable-list/selectable-list';

import type {NutshellState} from '../../../../../../store';
// @ts-expect-error
import * as dashboardSelectors from '../../../../dashboard-selectors';

import styles from './list-form.module.css';

type OwnProps = {
    value: string;
    dash: any;
    updateValue: (newValue: string) => void;
    onFormNameChange: (newName: string) => void;
};

type StateProps = {
    savedLeadLists: any[];
    savedCompanyLists: any[];
    savedPeopleLists: any[];
    currentUserId: string | null | undefined;
};

type Props = OwnProps & StateProps;

type State = {
    type: 'leads' | 'companies' | 'people';
    onlyShowMyLists: boolean;
};

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        savedLeadLists: dashboardSelectors.getSavedLeadLists(state),
        savedCompanyLists: dashboardSelectors.getSavedCompanyLists(state),
        savedPeopleLists: dashboardSelectors.getSavedPeopleLists(state),
        currentUserId: Session.getSessionStateUserId(state),
    };
};

export class ListFormComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const listType = props.dash.data && props.dash.data.list && props.dash.data.list.reportType;
        const typeMap = {
            entity_list_leads: 'leads',
            entity_list_accounts: 'companies',
            entity_list_contacts: 'people',
        } as const;
        this.state = {
            // @ts-expect-error
            type: typeMap[listType] || 'leads',
            onlyShowMyLists: false,
        };
    }

    render() {
        const formValues = Routing.deparam(this.props.value);
        const selectedListId = formValues.listId;
        const radioButtons = ['leads', 'companies', 'people'];
        const displayedLists = this.getDisplayedLists();

        const filteredSavedLists = displayedLists.filter((list) => {
            if (this.state.onlyShowMyLists) {
                return list.links.user === this.props.currentUserId && !list.isImmutable;
            } else {
                return true;
            }
        });

        return (
            <div className={styles.container}>
                <div className={styles['type-container']}>
                    <RadioGroupSlider
                        name='listType'
                        size='big'
                        selectedValue={this.state.type}
                        selectedIndex={radioButtons.indexOf(this.state.type)}
                        onChange={(type) => {
                            // @ts-expect-error
                            this.setState({type});
                        }}
                    >
                        <Radio value='leads'>Leads</Radio>
                        <Radio value='companies'>Companies</Radio>
                        <Radio value='people'>People</Radio>
                    </RadioGroupSlider>
                </div>
                <h3 className={styles.label}>Saved lists</h3>
                <div className={styles['selectable-list-container']}>
                    <div className={styles['my-lists-checkbox']}>
                        <Checkbox
                            label='Just my lists'
                            checked={this.state.onlyShowMyLists}
                            onChange={this.handleOnlyMyListsClick}
                        />
                    </div>
                    {/* @ts-expect-error */}
                    <SelectableListSingle
                        alwaysHasValue={true}
                        value={selectedListId}
                        collection={filteredSavedLists}
                        onSelect={this.handleChange}
                        emptyStateComponent={
                            <div style={{marginTop: 15, fontSize: 15, textAlign: 'center'}}>
                                <img
                                    style={{width: 250}}
                                    src='/include/images/dashboard/my-saved-lists-empty_2x.png'
                                />
                                <p
                                    style={{
                                        marginTop: 10,
                                        marginBottom: 5,
                                        fontWeight: 500,
                                        color: '#45423e',
                                    }}
                                >
                                    You haven’t saved any lists
                                </p>
                                <p style={{marginTop: 0, marginBottom: 15, fontSize: 13}}>
                                    Create a saved list from any list page
                                </p>
                            </div>
                        }
                    />
                </div>
                <div className={styles['create-new-list-link']}>
                    <a href={`/${this.state.type}`}>Create a new saved list</a>
                </div>
            </div>
        );
    }

    handleOnlyMyListsClick = () => {
        this.setState((prevState) => {
            const showOnlyMine = !prevState.onlyShowMyLists;

            return {
                onlyShowMyLists: showOnlyMine,
            };
        });
    };

    handleChange = (listId?: string | null) => {
        // Won't ever happen, but flow typing is a bit weak when `alwaysHasValue` is `true`
        if (!listId) return;

        this.props.updateValue(`listId=${listId}`);
        const chosenList = this.getDisplayedLists().find((list) => list.id === listId);
        if (chosenList) {
            this.props.onFormNameChange(chosenList.name);
        }
    };

    getDisplayedLists = () => {
        switch (this.state.type) {
            case 'leads':
                return this.props.savedLeadLists;
            case 'companies':
                return this.props.savedCompanyLists;
            case 'people':
                return this.props.savedPeopleLists;
            default:
                return this.props.savedLeadLists;
        }
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const ListForm = connector(ListFormComponent);
